import { Perk, Work } from 'src/types';

import SvgFacebook from 'src/images/specialPage/btn-facebook.svg';
import SvgInstagram from 'src/images/specialPage/btn-instagram.svg';
import SvgLinkedin from 'src/images/specialPage/btn-linkedin.svg';
// import SvgKakao from 'src/images/specialPage/btn-kakao.svg';
import SvgTechblog from 'src/images/specialPage/btn-techblog.svg';
import SvgFacebookHover from 'src/images/specialPage/btn-facebook-hover.svg';
import SvgInstagramHover from 'src/images/specialPage/btn-instagram-hover.svg';
import SvgLinkedinHover from 'src/images/specialPage/btn-linkedin-hover.svg';
// import SvgKakaoHover from 'src/images/specialPage/btn-kakao-hover.svg';
import SvgTechblogHover from 'src/images/specialPage/btn-techblog-hover.svg';

export const BASE_URL = 'https://career.hyperconnect.com';

export const START_DATE = '2022-06-13 00:00:00';

export const END_DATE = '2022-07-10 23:59:59';

export const INVITE_URL =
  'https://calendar.google.com/event?action=TEMPLATE&tmeid=Mmo1cHE0cG9ocWVjaWU3aTZnb3ZudDFsaG8gaHBjbnQuY29tXzNpMWxib2hrYzlodTZxMGp0YWZqdmFkanNvQGc&tmsrc=hpcnt.com_3i1lbohkc9hu6q0jtafjvadjso%40group.calendar.google.com';

export const RECOMMEND_URL =
  'https://jobs.lever.co/hpcnt/930054f7-4f4f-4c44-b367-bfb12a3d162d';

export const APPLY_URL =
  'https://career.hyperconnect.com/jobs/?team=%EB%A6%B4%EB%A0%88%EC%9D%B4%20%EC%B1%84%EC%9A%A9';

export const SHARE_BUTTON_LINKS = [
  {
    icon: SvgFacebook,
    hovered: SvgFacebookHover,
    link(url: string) {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        url
      )}&src=sdkpreparse`;
    },
  },
  {
    icon: SvgLinkedin,
    hovered: SvgLinkedinHover,
    link(url: string) {
      return `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
        url
      )}`;
    },
  },
  // {
  //   icon: SvgKakao,
  //   hovered: SvgKakaoHover,
  //   link(url: string) {
  //     return `kakaolink://sendurl?url=${url}`;
  //   },
  // },
];

export const FOOTER_BUTTON_LINKS = [
  {
    icon: SvgLinkedin,
    hovered: SvgLinkedinHover,
    link: 'https://www.linkedin.com/company/hyperconnect/',
  },
  {
    icon: SvgInstagram,
    hovered: SvgInstagramHover,
    link: 'https://www.instagram.com/hyperconnect/',
  },
  {
    icon: SvgFacebook,
    hovered: SvgFacebookHover,
    link: 'https://www.facebook.com/hpcnt',
  },
  {
    icon: SvgTechblog,
    hovered: SvgTechblogHover,
    link: 'https://hyperconnect.github.io/',
  },
];

export const WORK: Work[] = [
  {
    title: 'Proactive',
    description: '스스로 업무를 정의하고 수행하는 사람',
    icon: 'icons/img-proactive.svg',
    hoverIcon: 'icons/img-proactive-hover.svg',
  },
  {
    title: 'One team',
    description:
      '나의 팀 뿐 아니라 하이퍼커넥트 차원의 의미와 영향을 생각하며 일하는 사람',
    icon: 'icons/img-one-team.svg',
    hoverIcon: 'icons/img-one-team-hover.svg',
  },
  {
    title: 'Aim High',
    description: '높은 성취 기준을 추구하는 사람',
    icon: 'icons/img-aim-high.svg',
    hoverIcon: 'icons/img-aim-high-hover.svg',
  },
  {
    title: 'Prioritize',
    description: '진짜로 중요한 일에 집중하는 사람',
    icon: 'icons/img-prioritize.svg',
    hoverIcon: 'icons/img-prioritize-hover.svg',
  },
  {
    title: 'Move fast',
    description: '빠르게 움직여 일이 이뤄지도록 만드는 사람',
    icon: 'icons/img-move-fast.svg',
    hoverIcon: 'icons/img-move-fast-hover.svg',
  },
  {
    title: 'Logical',
    description: '자신의 관점을 갖고 논리적으로 소통하는 사람',
    icon: 'icons/img-logical.svg',
    hoverIcon: 'icons/img-logical-hover.svg',
  },
  {
    title: 'Open',
    description: '더 나은 결과를 위해 솔직하게 말하는 사람',
    icon: 'icons/img-open.svg',
    hoverIcon: 'icons/img-open-hover.svg',
  },
];

export const PERKS_WORK_LIFE_BALANCE: Perk[] = [
  {
    title: '💻 유연한 근무환경',
    desc: 'Hybrid 근무제 (Remote/Office 근무 가능)\nDIY 근무제 (근무/휴게 시간 자율 운영)',
  },
  {
    title: '🌴 다양한 휴가',
    desc: '본인 및 가족 생일, 리프레시 휴가 등',
  },
];

export const PERKS_PROFESSIONAL_DEVELOPMENT: Perk[] = [
  {
    title: '📖 교육 지원',
    desc: '어학, 직무 교육 비용 지원 및 사내 교육 프로그램 운영',
  },
  {
    title: '👫 지식 공유 밋업',
    desc: '직무별 Rel (개발, 디자인, PM) 활동',
  },
  {
    title: '👥 멘토링',
    desc: '멘토십 프로그램을 통해\nMatch Group 내 글로벌 동료들과 교류',
  },
  {
    title: '🎯 코칭 서비스',
    desc: '글로벌 코치 Pool을 활용한 1:1 코칭 지원\n(커리어, 리더십, 퍼포먼스 코칭 등)',
  },
];

export const PERKS_HEALTH_AND_WELLNESS: Perk[] = [
  {
    title: '🏥 단체보험',
    desc: '종합 보험 및 선택형 (치과, 수술, 실비) 보험 지원',
  },
  {
    title: '💊 건강 검진',
    desc: '종합 건강검진 격년 지원',
  },
  {
    title: '💉 백신',
    desc: '독감 예방접종 비용 지원',
  },
  {
    title: '🛏 하이퍼 힐링존',
    desc: '전문 안마사 상주 마사지 프로그램\n운영 및 안마의자 별도 비치',
  },
  {
    title: '💟 Mental Care',
    desc: '개인 심리 상담\n가족과 함께 참여 가능한 카운슬링 서비스 지원',
  },
];

export const PERKS_EMPLOYEE_PERKS: Perk[] = [
  {
    title: '📬 복지포인트',
    desc: '사내 복지몰에서 이용 가능한 복지포인트 지급',
  },
  {
    title: '🍵 사내 카페',
    desc: '음료 및 베이커리 무료로 이용 가능한 Hypresso',
  },
  {
    title: '🍴 식사 비용',
    desc: '점심, 야근 식대 지원',
  },
  {
    title: '👪 경조사',
    desc: '임직원 화환 경조사비 지급',
  },
  {
    title: '🎡 워크샵',
    desc: '팀빌딩을 위한 워크샵 및 행사',
  },
  {
    title: '🌀 사내 동호회',
    desc: '사내 교류 및 취미 활동을 위한 동호회비 지원',
  },
];

export const CAVEATS = [
  '하이퍼커넥트는 증명사진, 주민등록번호, 가족관계, 혼인여부 등 채용과 관계없는 개인정보를 요구하지 않습니다.',
  '제출해 주신 내용 중 허위 사실이 있을 경우 채용이 취소될 수 있습니다.',
  '국가유공자 및 장애인 등 취업보호대상자는 관계법령에 따라 우대합니다.',
  '수습기간 중 급여 등 처우에 차등이 없습니다.',
  '하이퍼커넥터가 아니더라도 지인을 추천하여 후보자가 최종합격 및 수습 통과 시, 누구나 추천 보상금을 받을 수 있습니다. (릴레이 채용 기간 200만 원 보상금 지급)',
];
